let installed = false

function getNumberInputFromWheelEvent(event: WheelEvent): HTMLInputElement | null {
  const path = typeof event.composedPath === 'function' ? event.composedPath() : []

  for (const target of path) {
    if (target instanceof HTMLInputElement && target.type === 'number') {
      return target
    }
  }

  return event.target instanceof HTMLInputElement && event.target.type === 'number'
    ? event.target
    : null
}

export function installNumberInputWheelGuard() {
  if (installed || typeof document === 'undefined') return

  document.addEventListener(
    'wheel',
    (event) => {
      const input = getNumberInputFromWheelEvent(event)

      if (!input || input.disabled || input.readOnly) return

      if (document.activeElement === input) {
        input.blur()
      }
    },
    { capture: true, passive: true }
  )

  installed = true
}
